function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cf5285;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M17.058,14.829l.166.167.168-.167a2.123,2.123,0,0,1,3,3L17.224,21l-3.168-3.169a2.123,2.123,0,0,1,3-3Zm-5.51-1.565v1.887a5.66,5.66,0,0,0-5.66,5.66H4a7.547,7.547,0,0,1,7.311-7.543ZM11.547,1a5.66,5.66,0,0,1,.212,11.317l-.212,0A5.66,5.66,0,0,1,11.335,1Zm0,1.887A3.774,3.774,0,1,0,15.321,6.66,3.773,3.773,0,0,0,11.547,2.887Z",
  transform: "translate(-4 -1)"
});

function SvgProfil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.015,
    height: 20,
    viewBox: "0 0 17.015 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.a08d6902c9600a9acc7a24cfa440d799.svg";
export { ForwardRef as ReactComponent };